import React, { useState } from "react";
import AbOwl from "./AbOwl";
import { splitAbCards } from "./abCards";
import CardImg from "../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

// Owl responsive items (viewport width): 0 → 3, 320 → 3, 768 → 4
const owlItems = () => ((typeof window !== "undefined" ? window.innerWidth : 1920) >= 768 ? 4 : 3);

/**
 * Andar / Bahar card sliders for Andar Bahar 50 / 150 cards (ab3 / ab4), reference markup.
 * Reference splits the feed `card` string: index even → Bahar, odd → Andar ("1" skipped), each
 * reversed (newest first) into an rtl Owl slider of <div.item><span><img></span></div>.
 *
 * variant "video" (desktop, ≥1280 at load): inside .casino-video
 *   .casino-video-cards.d-none-small[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > .row.row5.align-items-center > .col-1 (A / B) + .col-11 (2 × .card-inner > slider)
 * variant "detail" (reference IS_MOBILE, <1280 at load): first child of .casino-detail
 *   .casino-video-cards.d-none-desktop > .casino-video-cards-container > … .col-9 …
 */
function Slider({ id, list, resetKey }) {
  return (
    <AbOwl id={id} className="ab-slider owl-carousel owl-theme" items={owlItems()} resetKey={resetKey}>
      {list.map((c, i) => (
        <div key={`${i}-${c}`} className="item">
          <span>
            <CardImg src={`${IMG}/${c}.png`} alt="" />
          </span>
        </div>
      ))}
    </AbOwl>
  );
}

export default function AbVideoCards({ cardString, variant = "video" }) {
  const [showCards, setShowCards] = useState(true);
  const { cards, andar, bahar } = splitAbCards(cardString);
  const key = cardString || "";

  const labels = (
    <div className="col-1">
      <div className="row row5">
        <div className="col-12 mb-3">
          <b>A</b>
        </div>
      </div>{" "}
      <div className="row row5">
        <div className="col-12">
          <b>B</b>
        </div>
      </div>
    </div>
  );

  if (variant === "detail") {
    return (
      <div className="casino-video-cards d-none-desktop">
        <div className="casino-video-cards-container">
          <div className="row row5 align-items-center">
            {labels}{" "}
            <div className="col-9">
              <div className="card-inner">
                <div className="row row5">
                  <div className="col-12">
                    <Slider id="andarSlider" list={andar} resetKey={key} />
                  </div>
                </div>
              </div>{" "}
              <div className="card-inner">
                <div className="row row5 mt-1">
                  <div className="col-12">
                    <Slider id="baharSlider" list={bahar} resetKey={key} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards d-none-small${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => bahar.length > 0 && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div className="row row5 align-items-center">
          {labels}{" "}
          <div className="col-11">
            <div className="card-inner mb-1">
              <div className="row row5">
                <div className="col-12">
                  <Slider id="andarSlider" list={andar} resetKey={key} />
                </div>
              </div>
            </div>{" "}
            <div className="card-inner">
              <div className="row row5">
                <div className="col-12">
                  <Slider id="baharSlider" list={bahar} resetKey={key} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
